import { BaseViewModel } from '../../../../../../../../models/base/base-view-model';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CannabinoidOrTerpeneFromPool } from '../../../shared/card-data-with-property-pooling';
import { TheWoodsCardData } from '../../../../../../../../models/print-cards/the-woods-card-data';
import { map } from 'rxjs/operators';

@Injectable()
export class TheWoodsPropertiesSectionViewModel extends BaseViewModel {
  private readonly _propertiesBasedOnPools = new BehaviorSubject<CannabinoidOrTerpeneFromPool[]>(null);
  public readonly propertiesBasedOnPools$ = this._propertiesBasedOnPools as Observable<CannabinoidOrTerpeneFromPool[]>;
  connectToPropertiesBasedOnPools(propertiesBasedOnPools: CannabinoidOrTerpeneFromPool[]) {
    this._propertiesBasedOnPools.next(propertiesBasedOnPools);
  }

  private readonly _cardData = new BehaviorSubject<TheWoodsCardData>(null);
  public readonly cardData$ = this._cardData as Observable<TheWoodsCardData>;
  connectToCardData(cardData: TheWoodsCardData) {
    this._cardData.next(cardData);
  }

  public readonly rangedUnits$ = this.cardData$.pipe(map(cardData => cardData?.displayCannabinoidInRanges()));
}
